import { CatalogEffects } from './catalog.effect';

export const effects: any[] = [CatalogEffects];
